<template>
  <div class="appBox">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "AppBox",
  props: {},
};
</script>

<style lang="scss" scoped>
.appBox {
  background: white;
  border-radius: 2px;
  padding: 20px;
}
</style>
